<template>
    <div>
        <div class="costCalculation-main">
            <div class="CostCalculation-title">{{$t('Bill.CostCalculation.title')}}</div>
            <div class="CostCalculation-top">
                <Row>
                    <Col span="4" style="float: right;">
                        <div class="costCalculationSearch">
                            <Select filterable placeholder="请选择地区" v-model="region" @on-change="selectRegion(region)" :disabled="isChange">
                                <Option v-for="item in regionList" :value="item.value" :key="item.value">{{ item.label }}</Option>
                            </Select>
                        </div>
                    </Col>
                    <Col span="2" style="float: right;">
                        <i-switch size="large" :disabled="!(disabled && switch1)" on-change="changeSwitch" :value="moneyType" v-model="switch1" style="margin-top:15px;">
                            <span slot="open">$</span>
                            <span slot="columnsEC2">￥</span>
                        </i-switch>
                    </Col>
                    <Col span="12" style="margin-top: 12px;margin-left:10px">
                        <Button type="info" @click="cleanDate"><Icon type="ios-refresh" style="font-size:14px;margin-left: -7px;"/>{{$t('Bill.CostCalculation.reset')}}</Button>
                    </Col>
                </Row>
            </div>
            <!-- EC2 -->
            <div class="EC2-title">
                <div>{{$t('Bill.CostCalculation.EC2')}}</div>
                <add-elastic-compute-cloud :regionDate="region" v-on:addEC2CallBack="addEC2"></add-elastic-compute-cloud>
            </div>
            <Table :no-data-text="$t('common.noData')" :columns="columnsEC2" :data="elasticComputeCloudList"></Table>
            <div class="EC2-foot">
                <div v-show="EC2beiJingTotal">{{$t('Bill.CostCalculation.subtotal')}}: {{moneyIconEC}}{{EC2priceTotalBeijing}}</div>
                <div v-show="EC2singaporeTotal">{{$t('Bill.CostCalculation.subtotal')}}: {{moneyIconSingaporeEC}}{{EC2priceTotalSingapore}}</div>
            </div>
            <!-- EBS -->
            <div class="EBS-title">
                <div>{{$t('Bill.CostCalculation.storage')}}</div>
                <add-elastic-block-store :regionEBSDate="region" v-on:addEBSCallBack="addEBS"></add-elastic-block-store>
            </div>
            <Table :no-data-text="$t('common.noData')" :columns="columnsEBS" :data="tableElasticBlockStoreDate"></Table>
            <div class="EBS-foot">
                <div v-show="EBSbeiJingTotal">{{$t('Bill.CostCalculation.subtotal')}}: {{moneyIconEBS}}{{EBSpriceTotalBeijing}}</div>
                <div v-show="EBSsingaporeTotal">{{$t('Bill.CostCalculation.subtotal')}}: {{moneyIconSingaporeEBS}}{{EBSpriceTotalSingapore}}</div>
            </div>
            <!-- RDS -->
            <div class="RDS-title">
                <div>{{$t('Bill.CostCalculation.RDS')}}</div>
                <add-relational-database-service :regionRDSDate="region" v-on:addRDSCallBack="addRDS"></add-relational-database-service>
            </div>
            <Table :no-data-text="$t('common.noData')" :columns="columnsRDS" :data="relationalDatabaseServiceList"></Table>
            <div class="RDS-foot">
                <div v-show="RDSbeiJingTotal">{{$t('Bill.CostCalculation.subtotal')}}: {{moneyIconRDS}}{{RDSpriceTotalBeijing}}</div>
                <div v-show="RDSsingaporeTotal">{{$t('Bill.CostCalculation.subtotal')}}: {{moneyIconSingaporeRDS}}{{RDSpriceTotalSingapore}}</div>
            </div>
        </div>

        <!-- 尾 -->
        <div class="CostCalculation-foot">
            <Row>
                <Col span="16">
                    <Col span="8" class="total">
                        <div v-show="awsBeijing">{{$t('Bill.CostCalculation.AWSTotal')}}: {{moneyIconBeijing}}{{BeijingAWSTotal}} / {{$t('Bill.CostCalculation.year')}}</div>
                        <div v-show="awsSingapore">{{$t('Bill.CostCalculation.AWSTotal')}}: {{moneyIconSingapore}}{{SingaporeAWSTotal}} / {{$t('Bill.CostCalculation.year')}}</div>
                    </Col>
                </Col>
                <Col span="7">
                    <Col span="9">
                        <Select v-model="projects" @on-change="find(projects)">
                            <Option :value="item.id" v-for="(item,index) in projectList" v-bind:key="index">{{item.name}}</Option>
                        </Select>
                    </Col>
                    <Col span="6">
                        <Button type="primary" @click="modal1 = true" style="margin-left: 10px;" :disabled="isSaveScenarios">保存方案</Button>
                    </Col>
                    <Col span="6">
                        <span @click="saveProject">
                            <Button type="primary" style="margin-left: 10px;" :disabled="isSaveas">另存为</Button>
                        </span>
                    </Col>
                    <Col span="2">
                        <Button type="warning" :disabled="isExport" @click="exportProject">导出报表</Button>
                    </Col>
                </Col>
            </Row>
        </div>
        <!-- 保存方案 -->
        <Modal v-model="modal1" title="保存方案" :loading="loading" @on-ok="handleSubmit('preservationPlanForm')" @on-cancel="handleReset('preservationPlanForm')" :mask-closable="false">
            <Form ref="preservationPlanForm" :model="preservationPlanForm" :label-width="100" :rules="ruleValidate">
                <!-- 名称 -->
                <FormItem label="名称" prop="name">
                    <Input v-model="preservationPlanForm.name" placeholder="Enter something..." style="width:300px;"></Input>
                </FormItem>
                <!-- 描述 -->
                <FormItem label="描述" prop="describe">
                    <Input v-model="preservationPlanForm.describe" type="textarea" :autosize="{minRows: 2,maxRows: 5}" placeholder="Enter something..." style="width:300px;"></Input>
                </FormItem>
            </Form>
        </Modal>
        <!-- 另存为 -->
        <Modal v-model="modal2" title="另存为" :loading="loadingSaveAS" @on-ok="SaveAshandleSubmit('saveForm')" @on-cancel="SaveAshandleReset('saveForm')" :mask-closable="false">
            <Form ref="saveForm" :model="saveForm" :label-width="100" :rules="ruleValidateSave">
                <!-- 名称 -->
                <FormItem label="名称" prop="name">
                    <Input v-model="saveForm.name" placeholder="Enter something..." style="width:300px;"></Input>
                </FormItem>
                <!-- 描述 -->
                <FormItem label="描述" prop="describe">
                    <Input v-model="saveForm.describe" type="textarea" :autosize="{minRows: 2,maxRows: 5}" placeholder="Enter something..." style="width:300px;"></Input>
                </FormItem>
            </Form>
        </Modal>
    </div>
</template>

<script>
    import {setCookie,getCookie} from '../../../utils/cookieUtil.js'
    import AddElasticComputeCloud from '../cost_calculation/AddElasticComputeCloud'
    import AddElasticBlockStore from '../cost_calculation/AddElasticBlockStore'
    import AddRelationalDatabaseService from '../cost_calculation/AddRelationalDatabaseService'
    export default {
        name: 'CostCalculation',
        components: {
            AddElasticComputeCloud,
            AddElasticBlockStore,
            AddRelationalDatabaseService
        },
        data (){
            //添加
            var validAccess = (rule, value, callback) =>{
            var self = this;
            // 成本计算方案，名称要唯一
            self.$api.project.selectByName("name",this.preservationPlanForm.name)
                .then(res => {
                    // 名字重复了
                    if(res.data.id&&res.data.id>0){
                        callback(new Error('当前名称已存在!'));
                    }else{
                        callback();
                    }
                })
            };
            return {
                preInstalledSoftware:'',
                ec2Length:0,  // 小计几个
                EBSLength:0,
                RDSLength:0,
                moneyIconEC:'', //小计北京 ￥
                moneyIconEBS:'',
                moneyIconRDS:'',
                moneyIconSingaporeEC:'', // 小计新加坡 $
                moneyIconSingaporeEBS:'',
                moneyIconSingaporeRDS:'',
                EC2priceTotalBeijing:0.00, // 小计 EC2
                EC2priceTotalSingapore:0.00,
                EBSpriceTotalBeijing:0.00, // 小计 EBS
                EBSpriceTotalSingapore:0.00,
                RDSpriceTotalBeijing:0.00,// 小计 RDS
                RDSpriceTotalSingapore:0.00,
                moneyIconBeijing:'￥', //总计 ￥ $
                moneyIconSingapore:'$',
                BeijingAWSTotal: 0.00, // 总计价格
                SingaporeAWSTotal: 0.00,
                EC2beiJingTotal: true, // 四个小计根据条件显示隐藏
                EC2singaporeTotal:false,
                EBSbeiJingTotal: true,
                EBSsingaporeTotal:false,
                RDSbeiJingTotal: true,
                RDSsingaporeTotal:false,
                awsBeijing:true, // 两个总计根据条件显示隐藏
                awsSingapore:false,
                eventEC2:'',//用途
                eventEBS:'',
                preservationPlanForm: {  //保存方案
                    name: '',
                    describe:''
                },
                saveForm: {  //另存为
                    name: '',
                    describe:''
                },
                modal2:false,  // 另存为模式框
                projectList:[],
                projects:'',
                ec2Id:'',
                ebsId:'',
                projectId:'',
                isSaveScenarios:true,
                isSaveas:true,
                isExport:true,
                modal1:false,  // 保存方案模式框
                loading: true,
                loadingSaveAS:true,
                os:["Red Hat Enterprise Linux","Windows","Linux/UNIX","WindowsWithSQLEnterprise","WindowsWithSQLStandard"],
                dbType:["MySQL","SQLServerEnterprise","SQLServerStandard"],
                deploymentOption:["单区域","多区域"],
                paymentType:["按需实例","无前期费用(标准1年)"],
                categorys:["通用型(SSD)卷","预配置IOPS(SSD)卷","吞吐量优化型(HDD)卷","Cold HDD卷","EBS快照"],
                storageTypes:["EBS","RDS"],
                regionList: [    // 区域
                    {
                        value: '北京',
                        label: '北京'
                    },
                    {
                        value: '新加坡',
                        label: '新加坡'
                    }
                ],
                region:'北京',
                moneyType:false,
                switch1:false,
                disabled:false,
                isChange:false,
                columnsEC2: [
                    {
                        title: this.$t('Bill.CostCalculation.purpose'),
                        key: 'usage',
                        render: (h,params) => {
                            let self=this;
                            return h('Input',{
                                props:{
                                    type:'text',
                                    value:params.row.usage
                                },
                                on: {
                                    'input': function(eventEC2){
                                        self.elasticComputeCloudList[params.index].usage=eventEC2;
                                    }
                                }
                            });
                        }
                    },
                    {
                        title: this.$t('Bill.CostCalculation.region'),
                        key: 'region'
                    },
                    {
                        title: 'CPU',
                        key: 'cpuCoreNumber'
                    },
                    {
                        title: this.$t('Bill.CostCalculation.cache'),
                        key: 'ramSize'
                    },
                    {
                        title: this.$t('Bill.CostCalculation.OS'),
                        key: 'os'
                    },
                    {
                        title: this.$t('Bill.CostCalculation.paymentMethod'),
                        key: 'paymentType'
                    },
                    {
                        title: this.$t('Bill.CostCalculation.amount'),
                        key: 'number',
                        render: (h,params) => {
                            let self=this;
                            return h('InputNumber',{
                                attrs:{
                                    value: params.row.number,
                                    'min':1
                                },
                                on: {
                                    'on-change': function(event){
                                        //价格
                                        self.elasticComputeCloudList[params.index].number=event;
                                        self.updateEC2Price();
                                    }
                                }
                            });
                        }
                    },
                    {
                        title: this.$t('Bill.CostCalculation.unitPrice'),
                        key: 'cost'
                    },
                    {
                        title: this.$t('Bill.CostCalculation.month'),
                        key: 'month',
                        render: (h,params) => {
                            let self=this;
                            return h('InputNumber',{
                                attrs:{
                                    value: params.row.month,
                                    'min':1
                                },
                                on: {
                                    'on-change': function(event){
                                        //价格
                                        self.elasticComputeCloudList[params.index].month=event;
                                        self.updateEC2Price();
                                    }
                                }
                            });
                        }
                    },
                    {
                        title: this.$t('Bill.CostCalculation.price'),
                        key: 'allPrice'
                    },
                    {
                        title: this.$t('Bill.CostCalculation.operation'),
                        key: 'delete',
                        render: (h,params) => {
                            return h('Button',{
                                props: {
                                    type: 'error',
                                    size: 'small'
                                },
                                on: {
                                    click: () => {
                                        this.removeEC(params.index)
                                    }
                                }
                            },'删除');
                        }
                    }
                ],
                columnsEBS: [
                    {
                        title: this.$t('Bill.CostCalculation.purpose'),
                        key: 'usage',
                        render: (h,params) => {
                            let self=this;
                            return h('Input',{
                                props:{
                                    type:'text',
                                    value:params.row.usage
                                },
                                on: {
                                    'input': function(eventEBS){
                                        self.tableElasticBlockStoreDate[params.index].usage=eventEBS;
                                    }
                                }
                            });
                        }
                    },
                    {
                        title: this.$t('Bill.CostCalculation.region'),
                        key: 'region'
                    },
                    {
                        title: this.$t('Bill.CostCalculation.storageType'),
                        key: 'category'
                    },
                    {
                        title: this.$t('Bill.CostCalculation.serviceType'),
                        key: 'storageType'
                    },
                    {
                        title: this.$t('Bill.CostCalculation.storageCapacity'),
                        key: 'storage'
                    },
                    {
                        title: this.$t('Bill.CostCalculation.preConfigIOPS'),
                        key: 'iops'
                    },
                    {
                        title: this.$t('Bill.CostCalculation.amount'),
                        key: 'number',
                        render: (h,params) => {
                          let self=this;
                          return h('InputNumber',{
                              attrs:{
                                  value: params.row.number,
                                  'min':1
                              },
                              on: {
                                  'on-change': function(event){
                                      //价格
                                      self.tableElasticBlockStoreDate[params.index].number=event;
                                      self.updateEBSPrice();
                                  }
                              }
                          });
                      }
                    },
                    {
                        title: this.$t('Bill.CostCalculation.unitPrice'),
                        key: 'cost'
                    },
                    {
                        title: this.$t('Bill.CostCalculation.month'),
                        key: 'month',
                        render: (h,params) => {
                            let self=this;
                            return h('InputNumber',{
                                attrs:{
                                    value: params.row.month,
                                    'min':1
                                },
                                on: {
                                    'on-change': function(event){
                                        //价格
                                        self.tableElasticBlockStoreDate[params.index].month=event;
                                        self.updateEBSPrice();
                                    }
                                }
                            });
                        }
                    },
                    {
                        title: this.$t('Bill.CostCalculation.price'),
                        key: 'allPrice'
                    },
                    {
                        title: this.$t('Bill.CostCalculation.operation'),
                        key: 'deleteEBS',
                        render: (h,params) => {
                            return h('Button',{
                                props: {
                                    type: 'error',
                                    size: 'small'
                                },
                                on: {
                                    click: () => {
                                        this.removeEBS(params.index)
                                    }
                                }
                            },'删除');
                        }
                    }
                ],
                columnsRDS: [
                    {
                        title: this.$t('Bill.CostCalculation.purpose'),
                        key: 'usage',
                        render: (h,params) => {
                            let self=this;
                            return h('Input',{
                                props:{
                                    type:'text',
                                    value:params.row.usage
                                },
                                on: {
                                    'input': function(eventRDS){
                                        self.relationalDatabaseServiceList[params.index].usage=eventRDS;
                                    }
                                }
                            });
                        }
                    },
                    {
                        title: this.$t('Bill.CostCalculation.region'),
                        key: 'region'
                    },
                    {
                        title: 'CPU',
                        key: 'cpuCoreNumber'
                    },
                    {
                        title: this.$t('Bill.CostCalculation.cache'),
                        key: 'ramSize'
                    },
                    {
                        title: this.$t('Bill.CostCalculation.databaseType'),
                        key: 'dbType'
                    },
                    {
                        title: this.$t('Bill.CostCalculation.paymentMethod'),
                        key: 'paymentType'
                    },
                    {
                        title: this.$t('Bill.CostCalculation.deploymentMethod'),
                        key: 'deploymentOption'
                    },
                    {
                        title: this.$t('Bill.CostCalculation.amount'),
                        key: 'number',
                        render: (h,params) => {
                           let self=this;
                           return h('InputNumber',{
                               attrs:{
                                   value: params.row.number,
                                   'min':1
                               },
                               on: {
                                   'on-change': function(event){
                                       //价格
                                       self.relationalDatabaseServiceList[params.index].number=event;
                                       self.updateRDSPrice();
                                   }
                               }
                           });
                       }
                    },
                    {
                        title: this.$t('Bill.CostCalculation.unitPrice'),
                        key: 'cost'
                    },
                    {
                        title: this.$t('Bill.CostCalculation.month'),
                        key: 'month',
                        render: (h,params) => {
                            let self=this;
                            return h('InputNumber',{
                                attrs:{
                                    value: params.row.month,
                                    'min':1
                                },
                                on: {
                                    'on-change': function(event){
                                        //价格
                                        self.relationalDatabaseServiceList[params.index].month=event;
                                        self.updateRDSPrice();
                                    }
                                }
                            });
                        }
                    },
                    {
                        title: this.$t('Bill.CostCalculation.price'),
                        key: 'allPrice'
                    },
                    {
                        title: this.$t('Bill.CostCalculation.operation'),
                        key: 'delete',
                        render: (h,params) => {
                            return h('Button',{
                                props: {
                                    type: 'error',
                                    size: 'small'
                                },
                                on: {
                                    click: () => {
                                        this.removeRDS(params.index)
                                    }
                                }
                            },'删除');
                        }
                    }
                ],
                ruleValidate: {
                    name: [
                        { required: true, message: '名称不能为空', trigger: 'blur' },
                        { validator: validAccess,trigger: 'blur'}
                    ],
                    describe: [
                        { required: true, message: '请输入描述', trigger: 'blur' },
                        { type: 'string', max: 100, message: '最多输入100个字符', trigger: 'blur' }
                    ]
                },
                ruleValidateSave: {
                    name: [
                        { required: true, message: '名称不能为空', trigger: 'blur' }
                    ],
                    describe: [
                        { required: true, message: '请输入描述', trigger: 'blur' },
                        { type: 'string', max: 100, message: '最多输入100个字符', trigger: 'blur' }
                    ]
                },
                elasticComputeCloudList:[],
                tableElasticBlockStoreDate:[],
                newTableElasticBlockStoreDate:[],
                newElasticComputeCloudList:[],
                newRelationalDatabaseServiceList:[],
                ec2IdList:[],
                ec2DTOListCopyList:[],
                RDSDTOListCopyList:[],
                ec2DTOListCopyListUpdate:[],
                ec2DTOListCopyListExport:[],
                ebsIdList:[],
                ebsDTOListCopyList:[],
                ebsDTONoListCopyList:[],
                ebsDTOListCopyListUpdate:[],
                RDSDTOListCopyListUpdate:[],
                ebsDTONoListCopyListUpdate:[],
                ebsDTOListCopyListExport:[],
                relationalDatabaseServiceList:[],
                RDSDTOListCopyListExport:[]
            }
        },
        mounted(){
            this.selectRegion();
            this.selectList();
        },
        methods: {
            //重置
            /**************************************************************************************/
            cleanDate:function(){
                //表格清空
                this.elasticComputeCloudList=[];
                this.tableElasticBlockStoreDate=[];
                this.relationalDatabaseServiceList=[];
                //小计 个数、价格清空
                this.ec2Length=0;
                this.RDSLength=0;
                this.EBSLength=0;
                this.EC2priceTotalBeijing=0.00;
                this.EC2priceTotalSingapore=0.00;
                this.RDSpriceTotalBeijing=0.00;
                this.RDSpriceTotalSingapore=0.00;
                this.EBSpriceTotalBeijing=0.00;
                this.EBSpriceTotalSingapore=0.00;
                //总计
                this.BeijingAWSTotal=0.00;
                this.SingaporeAWSTotal=0.00;
                //区域可以选
                this.isChange=false;
                //保存方案禁止点击
                this.isSaveScenarios=true;
                //导出报表禁止点击
                this.isExport=true;
                //另存为禁止点击
                this.isSaveas=true;
                //下拉选为空
                this.projects='请选择';

            },
            // 显示EC2
            /**************************************************************************************/
            //更新EC2价格
            updateEC2Price:function(){
                // 北京
                var priceEC2Bei=0.00;
                // 新加坡
                var priceEC2Singa=0.00;
                for(var i=0;i<this.elasticComputeCloudList.length;i++){
                    //价格
                    if(this.region=='北京'){
                        this.elasticComputeCloudList[i].allPrice=(this.elasticComputeCloudList[i].cost.replace('￥','').replace('$',''))*this.elasticComputeCloudList[i].month*this.elasticComputeCloudList[i].number;
                        this.elasticComputeCloudList[i].allPrice="￥"+this.elasticComputeCloudList[i].allPrice.toFixed(2);
                        //相加
                        priceEC2Bei+=(this.elasticComputeCloudList[i].cost.replace('￥','').replace('$',''))*this.elasticComputeCloudList[i].month*this.elasticComputeCloudList[i].number;
                    }else if(this.region=='新加坡'){
                        this.elasticComputeCloudList[i].allPrice=(this.elasticComputeCloudList[i].cost.replace('￥','').replace('$',''))*this.elasticComputeCloudList[i].month*this.elasticComputeCloudList[i].number;
                        this.elasticComputeCloudList[i].allPrice="$"+this.elasticComputeCloudList[i].allPrice.toFixed(2);
                        //相加
                        priceEC2Singa+=(this.elasticComputeCloudList[i].cost.replace('￥','').replace('$',''))*this.elasticComputeCloudList[i].month*this.elasticComputeCloudList[i].number;
                    }

                }
                if(priceEC2Bei==0){
                    priceEC2Bei=0.00;
                }
                if(priceEC2Singa==0){
                    priceEC2Singa=0.00;
                }
                //小计
                this.EC2priceTotalBeijing=priceEC2Bei.toFixed(2);
                this.EC2priceTotalSingapore=priceEC2Singa.toFixed(2);
                //个数
                this.ec2Length=this.elasticComputeCloudList.length;
                //总计
                this.BeijingAWSTotal=parseFloat(this.EC2priceTotalBeijing)+parseFloat(this.EBSpriceTotalBeijing)+parseFloat(this.RDSpriceTotalBeijing);
                this.BeijingAWSTotal=this.BeijingAWSTotal.toFixed(2);
                this.SingaporeAWSTotal=parseFloat(this.EC2priceTotalSingapore)+parseFloat(this.EBSpriceTotalSingapore)+parseFloat(this.RDSpriceTotalSingapore);
                this.SingaporeAWSTotal=this.SingaporeAWSTotal.toFixed(2);
            },
            addEC2:function(EC2List){
                //定义
                this.elasticComputeCloudList.push(EC2List);
                // 禁止切换区域
                if(this.elasticComputeCloudList.length>0&&!this.isChange){
                    this.isChange=true;
                    //保存方案
                    this.isSaveScenarios=false;
                    this.isExport=false;
                    //另存为
                    this.isSaveas=true;
                }
                //长度
                this.ec2Length=this.elasticComputeCloudList.length;
                var i=this.ec2Length-1;
                // cpu
                this.elasticComputeCloudList[i].cpuCoreNumber=this.elasticComputeCloudList[i].cpuCoreNumber+"核";
                // 内存
                this.elasticComputeCloudList[i].ramSize=this.elasticComputeCloudList[i].ramSize+"G";
                // 操作系统
                this.elasticComputeCloudList[i].os=this.os[this.elasticComputeCloudList[i].os];
                // 付费类型
                this.elasticComputeCloudList[i].paymentType=this.paymentType[this.elasticComputeCloudList[i].paymentType];


                //把实例类型和区域放到这个新数组里
                var NewElasticComputeCloudCopy=new Object();
                NewElasticComputeCloudCopy.instanceType=this.elasticComputeCloudList[i].instanceType;
                NewElasticComputeCloudCopy.region=this.elasticComputeCloudList[i].regions;
                this.newElasticComputeCloudList.push(NewElasticComputeCloudCopy);

                //价格
                /************************************************************************************/
                if(this.region=='北京')
                {
                    //单价
                    this.elasticComputeCloudList[i].cost="￥"+this.elasticComputeCloudList[i].priceBeijing;
                    //价格
                    this.elasticComputeCloudList[i].allPrice="￥"+this.elasticComputeCloudList[i].priceBeijing;
                }else if(this.region=='新加坡'){
                    //单价
                    this.elasticComputeCloudList[i].cost="$"+this.elasticComputeCloudList[i].priceSingapore;
                    //价格
                    this.elasticComputeCloudList[i].allPrice="$"+this.elasticComputeCloudList[i].priceSingapore;
                }
                // 默认都是一个月的小计
                this.updateEC2Price();
            },
            // 删除EC2
            removeEC:function(index){
                //var price=this.elasticComputeCloudList[index];
                this.elasticComputeCloudList.splice(index,1);
                // 禁止切换区域
                 if(this.elasticComputeCloudList.length==0&&this.tableElasticBlockStoreDate.length==0&&this.relationalDatabaseServiceList.length==0){
                    this.isChange=false;
                    this.isSaveScenarios=true;
                    this.isExport=true;
                    this.isSaveas=true;
                    //下拉选为空
                    this.projects='请选择';
                }
                this.updateEC2Price();
            },
            // 显示EBS
            /**************************************************************************************/
            //更新EBS价格
            updateEBSPrice:function(){
                // 北京
                var priceEBSBei=0.00;
                // 新加坡
                var priceEBSSinga=0.00;
                for(var i=0;i<this.tableElasticBlockStoreDate.length;i++){
                    //价格
                    if(this.region=='北京'){
                        this.tableElasticBlockStoreDate[i].allPrice=(this.tableElasticBlockStoreDate[i].cost.replace('￥','').replace('$',''))*this.tableElasticBlockStoreDate[i].month*this.tableElasticBlockStoreDate[i].number;
                        this.tableElasticBlockStoreDate[i].allPrice="￥"+this.tableElasticBlockStoreDate[i].allPrice.toFixed(2);
                        //相加
                        priceEBSBei+=(this.tableElasticBlockStoreDate[i].cost.replace('￥','').replace('$',''))*this.tableElasticBlockStoreDate[i].month*this.tableElasticBlockStoreDate[i].number;
                    }else if(this.region=='新加坡'){
                        this.tableElasticBlockStoreDate[i].allPrice=(this.tableElasticBlockStoreDate[i].cost.replace('￥','').replace('$',''))*this.tableElasticBlockStoreDate[i].month*this.tableElasticBlockStoreDate[i].number;
                        this.tableElasticBlockStoreDate[i].allPrice="$"+this.tableElasticBlockStoreDate[i].allPrice.toFixed(2);
                        //相加
                        priceEBSSinga+=(this.tableElasticBlockStoreDate[i].cost.replace('￥','').replace('$',''))*this.tableElasticBlockStoreDate[i].month*this.tableElasticBlockStoreDate[i].number;
                    }
                }
                if(priceEBSBei==0){
                    priceEBSBei=0.00;
                }
                if(priceEBSSinga==0){
                    priceEBSSinga=0.00;
                }
                //小计
                this.EBSpriceTotalBeijing=priceEBSBei.toFixed(2);
                this.EBSpriceTotalSingapore=priceEBSSinga.toFixed(2);

                //个数
                this.EBSLength=this.tableElasticBlockStoreDate.length;
                //总计
                this.BeijingAWSTotal=parseFloat(this.EC2priceTotalBeijing)+parseFloat(this.EBSpriceTotalBeijing)+parseFloat(this.RDSpriceTotalBeijing);
                this.BeijingAWSTotal=this.BeijingAWSTotal.toFixed(2);
                this.SingaporeAWSTotal=parseFloat(this.EC2priceTotalSingapore)+parseFloat(this.EBSpriceTotalSingapore)+parseFloat(this.RDSpriceTotalSingapore);
                this.SingaporeAWSTotal=this.SingaporeAWSTotal.toFixed(2);
            },
            addEBS:function(EBSList){
                // 定义
                this.tableElasticBlockStoreDate.push(EBSList);
                // 禁止切换区域
                if(this.tableElasticBlockStoreDate.length>0&&!this.isChange){
                    this.isChange=true;
                    this.isSaveScenarios=false;
                    this.isExport=false;
                    this.isSaveas=true;
                }
                // 长度
                this.EBSLength=this.tableElasticBlockStoreDate.length;
                var i=this.EBSLength-1;
                //存储类型
                this.tableElasticBlockStoreDate[i].category=this.categorys[this.tableElasticBlockStoreDate[i].category];

                //服务类型
                this.tableElasticBlockStoreDate[i].storageType=this.storageTypes[this.tableElasticBlockStoreDate[i].storageType];


                // 预配置的IOPS数量
                this.tableElasticBlockStoreDate[i].iops=this.tableElasticBlockStoreDate[i].iops;
                // if(this.tableElasticBlockStoreDate[i].iops == ''){
                //     this.tableElasticBlockStoreDate[i].iops = '---'
                // }else{
                //     this.tableElasticBlockStoreDate[i].iops=this.tableElasticBlockStoreDate[i].iops;
                // }

                // 单位
                var storage=this.tableElasticBlockStoreDate[i].unit==0?' GB':' TB';
                // 存储容量
                this.tableElasticBlockStoreDate[i].storage=this.tableElasticBlockStoreDate[i].storage+storage;

                //把存储类型和区域放到这个新数组里
                var TableElasticBlockStoreDateCopy=new Object();
                TableElasticBlockStoreDateCopy.category=this.tableElasticBlockStoreDate[i].categorys;
                TableElasticBlockStoreDateCopy.region=this.tableElasticBlockStoreDate[i].regions;
                this.newTableElasticBlockStoreDate.push(TableElasticBlockStoreDateCopy);


                //价格
                /************************************************************************************/
                if(this.region=='北京')
                {
                    //单价
                    this.tableElasticBlockStoreDate[i].cost="￥"+this.tableElasticBlockStoreDate[i].priceBeijing;
                    //价格
                    this.tableElasticBlockStoreDate[i].allPrice="￥"+this.tableElasticBlockStoreDate[i].priceBeijing;
                }else if(this.region=='新加坡'){
                    //单价
                    this.tableElasticBlockStoreDate[i].cost="$"+this.tableElasticBlockStoreDate[i].priceSingapore;
                    //价格
                    this.tableElasticBlockStoreDate[i].allPrice="$"+this.tableElasticBlockStoreDate[i].priceSingapore;
                }

                //默认都是一个月的小计
                this.updateEBSPrice();
            },
            // 删除EBS
            removeEBS:function(index){
                this.tableElasticBlockStoreDate.splice(index,1);
                // 禁止切换区域
                 if(this.elasticComputeCloudList.length==0&&this.tableElasticBlockStoreDate.length==0&&this.relationalDatabaseServiceList.length==0){
                    this.isChange=false;
                    this.isSaveScenarios=true;
                    this.isExport=true;
                    this.isSaveas=true;
                    //下拉选为空
                    this.projects='请选择';
                }
                this.updateEBSPrice();
            },
            // 显示RDS
            /**************************************************************************************/
            //更新RDS价格
            updateRDSPrice:function(){
                // 北京
                var priceRDSBei=0.00;
                // 新加坡
                var priceRDSSinga=0.00;
                for(var i=0;i<this.relationalDatabaseServiceList.length;i++){
                    //价格
                    if(this.region=='北京'){
                        this.relationalDatabaseServiceList[i].allPrice=(this.relationalDatabaseServiceList[i].cost.replace('￥','').replace('$',''))*this.relationalDatabaseServiceList[i].month*this.relationalDatabaseServiceList[i].number;
                        this.relationalDatabaseServiceList[i].allPrice="￥"+this.relationalDatabaseServiceList[i].allPrice.toFixed(2);
                        //相加
                        priceRDSBei+=(this.relationalDatabaseServiceList[i].cost.replace('￥','').replace('$',''))*this.relationalDatabaseServiceList[i].month*this.relationalDatabaseServiceList[i].number;
                    }else if(this.region=='新加坡'){
                        this.relationalDatabaseServiceList[i].allPrice=(this.relationalDatabaseServiceList[i].cost.replace('￥','').replace('$',''))*this.relationalDatabaseServiceList[i].month*this.relationalDatabaseServiceList[i].number;
                        this.relationalDatabaseServiceList[i].allPrice="$"+this.relationalDatabaseServiceList[i].allPrice.toFixed(2);
                        //相加
                        priceRDSSinga+=(this.relationalDatabaseServiceList[i].cost.replace('￥','').replace('$',''))*this.relationalDatabaseServiceList[i].month*this.relationalDatabaseServiceList[i].number;
                    }

                }
                if(priceRDSBei==0){
                    priceRDSBei=0.00;
                }
                if(priceRDSSinga==0){
                    priceRDSSinga=0.00;
                }
                //小计
                this.RDSpriceTotalBeijing=priceRDSBei.toFixed(2);
                this.RDSpriceTotalSingapore=priceRDSSinga.toFixed(2);
                //个数
                this.RDSLength=this.relationalDatabaseServiceList.length;
                //总计
                this.BeijingAWSTotal=parseFloat(this.EC2priceTotalBeijing)+parseFloat(this.EBSpriceTotalBeijing)+parseFloat(this.RDSpriceTotalBeijing);
                this.BeijingAWSTotal=this.BeijingAWSTotal.toFixed(2);
                this.SingaporeAWSTotal=parseFloat(this.EC2priceTotalSingapore)+parseFloat(this.EBSpriceTotalSingapore)+parseFloat(this.RDSpriceTotalSingapore);
                this.SingaporeAWSTotal=this.SingaporeAWSTotal.toFixed(2);
            },
            addRDS:function(RDSList){
                //定义
                this.relationalDatabaseServiceList.push(RDSList);
                // 禁止切换区域
                if(this.relationalDatabaseServiceList.length>0&&!this.isChange){
                    this.isChange=true;
                    //保存方案
                    this.isSaveScenarios=false;
                    this.isExport=false;
                    //另存为
                    this.isSaveas=true;
                }
                //长度
                this.RDSLength=this.relationalDatabaseServiceList.length;
                var i=this.RDSLength-1;
                // cpu
                this.relationalDatabaseServiceList[i].cpuCoreNumber=this.relationalDatabaseServiceList[i].cpuCoreNumber+"核";
                // 内存
                this.relationalDatabaseServiceList[i].ramSize=this.relationalDatabaseServiceList[i].ramSize+"G";
                // 数据库类型
                this.relationalDatabaseServiceList[i].dbType=this.dbType[this.relationalDatabaseServiceList[i].dbType];
                // 付费类型
                this.relationalDatabaseServiceList[i].paymentType=this.paymentType[this.relationalDatabaseServiceList[i].paymentType];
                // 部署方式
                this.relationalDatabaseServiceList[i].deploymentOption=this.deploymentOption[this.relationalDatabaseServiceList[i].deploymentOption];


                //把实例类型和区域放到这个新数组里
                var NewRelationalDatabaseServiceCopy=new Object();
                NewRelationalDatabaseServiceCopy.instanceType=this.relationalDatabaseServiceList[i].instanceType;
                NewRelationalDatabaseServiceCopy.region=this.relationalDatabaseServiceList[i].regions;
                this.newRelationalDatabaseServiceList.push(NewRelationalDatabaseServiceCopy);

                //价格
                /************************************************************************************/
                if(this.region=='北京')
                {
                    //单价
                    this.relationalDatabaseServiceList[i].cost="￥"+this.relationalDatabaseServiceList[i].priceBeijing;
                    //价格
                    this.relationalDatabaseServiceList[i].allPrice="￥"+this.relationalDatabaseServiceList[i].priceBeijing;
                }else if(this.region=='新加坡'){
                    //单价
                    this.relationalDatabaseServiceList[i].cost="$"+this.relationalDatabaseServiceList[i].priceSingapore;
                    //价格
                    this.relationalDatabaseServiceList[i].allPrice="$"+this.relationalDatabaseServiceList[i].priceSingapore;
                }
                // 默认都是一个月的小计
                this.updateRDSPrice();
            },
            // 删除RDS
            removeRDS:function(index){
                //var price=this.relationalDatabaseServiceList[index];
                this.relationalDatabaseServiceList.splice(index,1);
                // 禁止切换区域
                if(this.elasticComputeCloudList.length==0&&this.tableElasticBlockStoreDate.length==0&&this.relationalDatabaseServiceList.length==0){
                    this.isChange=false;
                    this.isSaveScenarios=true;
                    this.isExport=true;
                    this.isSaveas=true;
                    //下拉选为空
                    this.projects='请选择';
                }
                this.updateRDSPrice();
            },
            // 区域
            /**************************************************************************************/
            selectRegion: function(){
                if(this.region=='北京'){
                    //小计
                    this.EC2beiJingTotal=true;
                    this.EBSbeiJingTotal=true;
                    this.RDSbeiJingTotal=true;
                    this.RDSsingaporeTotal=false;
                    this.EC2singaporeTotal=false;
                    this.EBSsingaporeTotal=false;
                    //总计
                    this.awsBeijing=true;
                    this.awsSingapore=false;
                    //联动开关
                    this.switch1=false;
                    //单位
                    this.moneyIconEC="￥";
                    this.moneyIconRDS="￥";
                    this.moneyIconEBS="￥";
                }else if(this.region=='新加坡'){
                    //小计
                    this.EC2singaporeTotal=true;
                    this.EBSsingaporeTotal=true;
                    this.EC2beiJingTotal=false;
                    this.RDSbeiJingTotal=false;
                    this.RDSsingaporeTotal=true;
                    this.EBSbeiJingTotal=false;
                    //总计
                    this.awsBeijing=false;
                    this.awsSingapore=true;
                    //联动开关
                    this.switch1=true;
                    //单位
                    this.moneyIconSingaporeEC="$";
                    this.moneyIconSingaporeEBS="$";
                    this.moneyIconSingaporeRDS="$";
                }
            },
            // switch
            changeSwitch:function(status){
                this.disabled = false;
            },
            //导出报表
            /**************************************************************************************/
            exportProject:function(){
                //ec2用途不能为空
                /**********************************************************/
                if(this.elasticComputeCloudList.length>0){
                    for(var i=0;i<this.elasticComputeCloudList.length;i++){
                        if(this.elasticComputeCloudList[i].usage==undefined||this.elasticComputeCloudList[i].usage==''){
                            this.loading = false;
                            setTimeout(() => {
                                this.loading = true
                            }, 0)
                            this.$Message.error('导出失败,用途不能为空');
                            this.modal1 = false;
                            return;
                        }
                        if(this.elasticComputeCloudList[i].month==undefined||this.elasticComputeCloudList[i].month==''){
                            this.loading = false;
                            setTimeout(() => {
                                this.loading = true
                            }, 0)
                            this.$Message.error('导出失败,月不能为空');
                            this.modal1 = false;
                            return;
                        }
                    }
                }
                //ebs用途不能为空
                if(this.tableElasticBlockStoreDate.length>0){
                    for(var i=0;i<this.tableElasticBlockStoreDate.length;i++){
                        if(this.tableElasticBlockStoreDate[i].usage==undefined||this.tableElasticBlockStoreDate[i].usage==''){
                            this.loading = false;
                            setTimeout(() => {
                                this.loading = true
                            }, 0)
                            this.$Message.error('导出失败,用途不能为空');
                            this.modal1 = false;
                            return;
                        }
                        if(this.tableElasticBlockStoreDate[i].month==undefined||this.tableElasticBlockStoreDate[i].month==''){
                            this.loading = false;
                            setTimeout(() => {
                                this.loading = true
                            }, 0)
                            this.$Message.error('导出失败,月不能为空');
                            this.modal1 = false;
                            return;
                        }
                    }
                }
                //rds用途不能为空
                if(this.relationalDatabaseServiceList.length>0){
                    for(var i=0;i<this.relationalDatabaseServiceList.length;i++){
                        if(this.relationalDatabaseServiceList[i].usage==undefined||this.relationalDatabaseServiceList[i].usage==''){
                            this.loading = false;
                            setTimeout(() => {
                                this.loading = true
                            }, 0)
                            this.$Message.error('导出失败,用途不能为空');
                            this.modal1 = false;
                            return;
                        }
                        if(this.relationalDatabaseServiceList[i].month==undefined||this.relationalDatabaseServiceList[i].month==''){
                            this.loading = false;
                            setTimeout(() => {
                                this.loading = true
                            }, 0)
                            this.$Message.error('导出失败,月不能为空');
                            this.modal1 = false;
                            return;
                        }
                    }
                }
                this.ec2DTOListCopyListExport = [];
                // 增加ec2DTOList
                /**********************************************************/
                for(var i=0;i<this.elasticComputeCloudList.length;i++){
                    //区域
                    if(this.elasticComputeCloudList[i].region=='北京'){
                        this.elasticComputeCloudList[i].region='CN_NORTH_1';
                    }else if(this.elasticComputeCloudList[i].region=='新加坡'){
                        this.elasticComputeCloudList[i].region='AP_SOUTHEAST_1';
                    }


                    //操作系统
                    if(this.elasticComputeCloudList[i].os=='Windows'){
                        this.elasticComputeCloudList[i].os=1;
                    }else if(this.elasticComputeCloudList[i].os=='Red Hat Enterprise Linux'){
                        this.elasticComputeCloudList[i].os=0;
                    }else if(this.elasticComputeCloudList[i].os=='Linux/UNIX'){
                        this.elasticComputeCloudList[i].os=2;
                    }else if(this.elasticComputeCloudList[i].os=='WindowsWithSQLEnterprise'){
                        this.elasticComputeCloudList[i].os=1;
                    }else if(this.elasticComputeCloudList[i].os=='WindowsWithSQLStandard'){
                        this.elasticComputeCloudList[i].os=1;
                    }

                    var Ec2DTOListCopyExport=new Object();
                    Ec2DTOListCopyExport.region=this.elasticComputeCloudList[i].region;
                    Ec2DTOListCopyExport.cpuCoreNumber=this.elasticComputeCloudList[i].cpuCoreNumber.replace('核','');
                    Ec2DTOListCopyExport.ramSize=this.elasticComputeCloudList[i].ramSize.replace('G','');
                    Ec2DTOListCopyExport.os=this.elasticComputeCloudList[i].os;
                    Ec2DTOListCopyExport.paymentType=this.elasticComputeCloudList[i].paymentType;
                    Ec2DTOListCopyExport.number=this.elasticComputeCloudList[i].number;
                    Ec2DTOListCopyExport.cost=this.elasticComputeCloudList[i].cost.replace('￥','').replace('$','');
                    Ec2DTOListCopyExport.instanceType=this.elasticComputeCloudList[i].instanceType;
                    Ec2DTOListCopyExport.usage=this.elasticComputeCloudList[i].usage;
                    Ec2DTOListCopyExport.month=this.elasticComputeCloudList[i].month;
                    Ec2DTOListCopyExport.preInstalledSoftware=this.elasticComputeCloudList[i].preInstalledSoftware;
                    Ec2DTOListCopyExport.allPrice=this.elasticComputeCloudList[i].allPrice.replace('￥','').replace('$','');
                    this.ec2DTOListCopyListExport.push(Ec2DTOListCopyExport);
                }
                this.ebsDTOListCopyListExport = [];
                // 增加ebsDTOList
                /**********************************************************/
                for(var i=0;i<this.tableElasticBlockStoreDate.length;i++){
                    //区域
                    if(this.tableElasticBlockStoreDate[i].region=='北京'){
                        this.tableElasticBlockStoreDate[i].region='CN_NORTH_1';
                    }else if(this.tableElasticBlockStoreDate[i].region=='新加坡'){
                        this.tableElasticBlockStoreDate[i].region='AP_SOUTHEAST_1';
                    }

                    //存储类型
                    if(this.tableElasticBlockStoreDate[i].category=='通用型(SSD)卷'){
                        this.tableElasticBlockStoreDate[i].category=0;
                    }else if(this.tableElasticBlockStoreDate[i].category=='预配置IOPS(SSD)卷'){
                        this.tableElasticBlockStoreDate[i].category=1;
                    }else if(this.tableElasticBlockStoreDate[i].category=='吞吐量优化型(HDD)卷'){
                        this.tableElasticBlockStoreDate[i].category=2;
                    }else if(this.tableElasticBlockStoreDate[i].category=='Cold HDD卷'){
                        this.tableElasticBlockStoreDate[i].category=3;
                    }else if(this.tableElasticBlockStoreDate[i].category=='EBS快照'){
                        this.tableElasticBlockStoreDate[i].category=4;
                    }

                    //服务类型
                    if(this.tableElasticBlockStoreDate[i].storageType=='EBS'){
                        this.tableElasticBlockStoreDate[i].storageType=0;
                    }else if(this.tableElasticBlockStoreDate[i].storageType=='RDS'){
                        this.tableElasticBlockStoreDate[i].storageType=1;
                    }

                    // 有iops
                    var EbsDTOListCopyExport=new Object();
                    EbsDTOListCopyExport.region=this.tableElasticBlockStoreDate[i].region;
                    EbsDTOListCopyExport.category=this.tableElasticBlockStoreDate[i].category;
                    EbsDTOListCopyExport.storage=this.tableElasticBlockStoreDate[i].storage.replace('GB','').replace('TB','');
                    EbsDTOListCopyExport.number=this.tableElasticBlockStoreDate[i].number;
                    EbsDTOListCopyExport.iops=this.tableElasticBlockStoreDate[i].iops;
                    EbsDTOListCopyExport.cost=this.tableElasticBlockStoreDate[i].cost.replace('￥','').replace('$','');
                    EbsDTOListCopyExport.unit=this.tableElasticBlockStoreDate[i].unit;
                    EbsDTOListCopyExport.usage=this.tableElasticBlockStoreDate[i].usage;
                    EbsDTOListCopyExport.month=this.tableElasticBlockStoreDate[i].month;
                    EbsDTOListCopyExport.storageType=this.tableElasticBlockStoreDate[i].storageType;
                    EbsDTOListCopyExport.allPrice=this.tableElasticBlockStoreDate[i].allPrice.replace('￥','').replace('$','');
                    this.ebsDTOListCopyListExport.push(EbsDTOListCopyExport);

                }
                this.RDSDTOListCopyListExport=[];
                // 增加rdsDTOList
                /**********************************************************/
                for(var i=0;i<this.relationalDatabaseServiceList.length;i++){
                    //区域
                    if(this.relationalDatabaseServiceList[i].region=='北京'){
                        this.relationalDatabaseServiceList[i].region='CN_NORTH_1';
                    }else if(this.relationalDatabaseServiceList[i].region=='新加坡'){
                        this.relationalDatabaseServiceList[i].region='AP_SOUTHEAST_1';
                    }

                    //数据库类型
                    if(this.relationalDatabaseServiceList[i].dbType=='MySQL'){
                        this.relationalDatabaseServiceList[i].dbType=0;
                    }else if(this.relationalDatabaseServiceList[i].dbType=='SQLServerEnterprise'){
                        this.relationalDatabaseServiceList[i].dbType=1;
                    }else if(this.relationalDatabaseServiceList[i].dbType=='SQLServerStandard'){
                        this.relationalDatabaseServiceList[i].dbType=1;
                    }

                     //部署方式
                    if(this.relationalDatabaseServiceList[i].deploymentOption=='单区域'){
                        this.relationalDatabaseServiceList[i].deploymentOption=0;
                    }else if(this.relationalDatabaseServiceList[i].deploymentOption=='多区域'){
                        this.relationalDatabaseServiceList[i].deploymentOption=1;
                    }

                    var RDSDTOListCopyExport=new Object();
                    RDSDTOListCopyExport.usage=this.relationalDatabaseServiceList[i].usage;
                    RDSDTOListCopyExport.region=this.relationalDatabaseServiceList[i].region;
                    RDSDTOListCopyExport.cpuCoreNumber=this.relationalDatabaseServiceList[i].cpuCoreNumber.replace('核','');
                    RDSDTOListCopyExport.ramSize=this.relationalDatabaseServiceList[i].ramSize.replace('G','');
                    RDSDTOListCopyExport.dbType=this.relationalDatabaseServiceList[i].dbType;
                    RDSDTOListCopyExport.paymentType=this.relationalDatabaseServiceList[i].paymentType;
                    RDSDTOListCopyExport.deploymentOption=this.relationalDatabaseServiceList[i].deploymentOption;
                    RDSDTOListCopyExport.number=this.relationalDatabaseServiceList[i].number;
                    RDSDTOListCopyExport.cost=this.relationalDatabaseServiceList[i].cost.replace('￥','').replace('$','');
                    RDSDTOListCopyExport.month=this.relationalDatabaseServiceList[i].month;
                    RDSDTOListCopyExport.instanceType=this.relationalDatabaseServiceList[i].instanceType;
                    RDSDTOListCopyExport.dbEdition=this.relationalDatabaseServiceList[i].dbEdition;
                    RDSDTOListCopyExport.allPrice=this.relationalDatabaseServiceList[i].allPrice.replace('￥','').replace('$','');
                    this.RDSDTOListCopyListExport.push(RDSDTOListCopyExport);
                }
                if(this.region=='北京'){
                    // 下载Excel 文件
                    this.$api.project.exportProject({
                            "ebsDTOList": this.ebsDTOListCopyListExport,
                            "ec2DTOList": this.ec2DTOListCopyListExport,
                            "rdsDTOList": this.RDSDTOListCopyListExport,
                            "ebsTotalCost": this.EBSpriceTotalBeijing,
                            "ec2TotalCost": this.EC2priceTotalBeijing,
                            "rdsTotalCost": this.RDSpriceTotalBeijing,
                            "totalCost": this.BeijingAWSTotal
                        })
                        .then(res => {
                            let fileName = 'AWSCost.xls'
                            let blob = new Blob([res.data], { type: 'application/x-xls' })
                            if (window.navigator.msSaveOrOpenBlob) {
                                navigator.msSaveBlob(blob, fileName);
                            }else{
                                var link = document.createElement('a');
                                link.href = window.URL.createObjectURL(blob);
                                link.download = fileName;
                                link.click();
                                window.URL.revokeObjectURL(link.href);
                            }
                            this.$Message.success('导出成功');
                            this.cleanDate();
                        })
                }else if(this.region=='新加坡'){
                    // 下载Excel 文件
                    this.$api.project.exportProject({
                            "ebsDTOList": this.ebsDTOListCopyListExport,
                            "ec2DTOList": this.ec2DTOListCopyListExport,
                            "rdsDTOList": this.RDSDTOListCopyListExport,
                            "ebsTotalCost": this.EBSpriceTotalSingapore,
                            "ec2TotalCost": this.EC2priceTotalSingapore,
                            "rdsTotalCost": this.RDSpriceTotalSingapore,
                            "totalCost": this.SingaporeAWSTotal
                        })
                        .then(res => {
                            let fileName = 'AWSCost.xls'
                            let blob = new Blob([res.data], { type: 'application/x-xls' })
                            if (window.navigator.msSaveOrOpenBlob) {
                                navigator.msSaveBlob(blob, fileName);
                            }else{
                                var link = document.createElement('a');
                                link.href = window.URL.createObjectURL(blob);
                                link.download = fileName;
                                link.click();
                                window.URL.revokeObjectURL(link.href);
                            }
                            this.$Message.success('导出成功');
                            this.cleanDate();
                        })
                }

            },
            //保存方案
            /**************************************************************************************/
            handleSubmit: function(name) {
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        //ec2用途不能为空
                        /**********************************************************/
                        if(this.elasticComputeCloudList.length>0){
                            for(var i=0;i<this.elasticComputeCloudList.length;i++){
                                if(this.elasticComputeCloudList[i].usage==undefined||this.elasticComputeCloudList[i].usage==''){
                                    this.loading = false;
                                    setTimeout(() => {
                                        this.loading = true
                                    }, 0)
                                    this.$Message.error('保存失败,用途不能为空');
                                    this.modal1 = false;
                                    return;
                                }
                                if(this.elasticComputeCloudList[i].month==undefined||this.elasticComputeCloudList[i].month==''){
                                    this.loading = false;
                                    setTimeout(() => {
                                        this.loading = true
                                    }, 0)
                                    this.$Message.error('保存失败,月不能为空');
                                    this.modal1 = false;
                                    return;
                                }
                            }
                        }

                        //ebs用途不能为空
                        if(this.tableElasticBlockStoreDate.length>0){
                            for(var i=0;i<this.tableElasticBlockStoreDate.length;i++){
                                if(this.tableElasticBlockStoreDate[i].usage==undefined||this.tableElasticBlockStoreDate[i].usage==''){
                                    this.loading = false;
                                    setTimeout(() => {
                                        this.loading = true
                                    }, 0)
                                    this.$Message.error('保存失败,用途不能为空');
                                    this.modal1 = false;
                                    return;
                                }
                                if(this.tableElasticBlockStoreDate[i].month==undefined||this.tableElasticBlockStoreDate[i].month==''){
                                    this.loading = false;
                                    setTimeout(() => {
                                        this.loading = true
                                    }, 0)
                                    this.$Message.error('保存失败,月不能为空');
                                    this.modal1 = false;
                                    return;
                                }
                            }
                        }
                        //rds用途不能为空
                        if(this.relationalDatabaseServiceList.length>0){
                            for(var i=0;i<this.relationalDatabaseServiceList.length;i++){
                                if(this.relationalDatabaseServiceList[i].usage==undefined||this.relationalDatabaseServiceList[i].usage==''){
                                    this.loading = false;
                                    setTimeout(() => {
                                        this.loading = true
                                    }, 0)
                                    this.$Message.error('保存失败,用途不能为空');
                                    this.modal1 = false;
                                    return;
                                }
                                if(this.relationalDatabaseServiceList[i].month==undefined||this.relationalDatabaseServiceList[i].month==''){
                                    this.loading = false;
                                    setTimeout(() => {
                                        this.loading = true
                                    }, 0)
                                    this.$Message.error('保存失败,月不能为空');
                                    this.modal1 = false;
                                    return;
                                }
                            }
                        }

                        this.ec2DTOListCopyList=[];
                        // 增加ec2DTOList
                        /**********************************************************/
                        for(var i=0;i<this.elasticComputeCloudList.length;i++){
                            //区域
                            if(this.elasticComputeCloudList[i].region=='北京'){
                                this.elasticComputeCloudList[i].region='CN_NORTH_1';
                            }else if(this.elasticComputeCloudList[i].region=='新加坡'){
                                this.elasticComputeCloudList[i].region='AP_SOUTHEAST_1';
                            }

                            //操作系统
                            if(this.elasticComputeCloudList[i].os=='Windows'){
                                this.elasticComputeCloudList[i].os=1;
                            }else if(this.elasticComputeCloudList[i].os=='Red Hat Enterprise Linux'){
                                this.elasticComputeCloudList[i].os=0;
                            }else if(this.elasticComputeCloudList[i].os=='Linux/UNIX'){
                                this.elasticComputeCloudList[i].os=2;
                            }else if(this.elasticComputeCloudList[i].os=='WindowsWithSQLEnterprise'){
                                this.elasticComputeCloudList[i].os=1;
                            }else if(this.elasticComputeCloudList[i].os=='WindowsWithSQLStandard'){
                                this.elasticComputeCloudList[i].os=1;
                            }

                            var Ec2DTOListCopy=new Object();
                            Ec2DTOListCopy.region=this.elasticComputeCloudList[i].region;
                            Ec2DTOListCopy.cpuCoreNumber=this.elasticComputeCloudList[i].cpuCoreNumber.replace('核','');
                            Ec2DTOListCopy.ramSize=this.elasticComputeCloudList[i].ramSize.replace('G','');
                            Ec2DTOListCopy.os=this.elasticComputeCloudList[i].os;
                            Ec2DTOListCopy.paymentType=this.elasticComputeCloudList[i].paymentType;
                            Ec2DTOListCopy.number=this.elasticComputeCloudList[i].number;
                            Ec2DTOListCopy.cost=this.elasticComputeCloudList[i].cost.replace('￥','').replace('$','');
                            Ec2DTOListCopy.instanceType=this.elasticComputeCloudList[i].instanceType;
                            Ec2DTOListCopy.usage=this.elasticComputeCloudList[i].usage;
                            Ec2DTOListCopy.month=this.elasticComputeCloudList[i].month;
                            Ec2DTOListCopy.preInstalledSoftware=this.elasticComputeCloudList[i].preInstalledSoftware;
                            this.ec2DTOListCopyList.push(Ec2DTOListCopy);
                        }
                        this.ebsDTOListCopyList=[];
                        // 增加ebsDTOList
                        /**********************************************************/
                        for(var i=0;i<this.tableElasticBlockStoreDate.length;i++){
                            //区域
                            if(this.tableElasticBlockStoreDate[i].region=='北京'){
                                this.tableElasticBlockStoreDate[i].region='CN_NORTH_1';
                            }else if(this.tableElasticBlockStoreDate[i].region=='新加坡'){
                                this.tableElasticBlockStoreDate[i].region='AP_SOUTHEAST_1';
                            }

                            //存储类型
                            if(this.tableElasticBlockStoreDate[i].category=='通用型(SSD)卷'){
                                this.tableElasticBlockStoreDate[i].category=0;
                            }else if(this.tableElasticBlockStoreDate[i].category=='预配置IOPS(SSD)卷'){
                                this.tableElasticBlockStoreDate[i].category=1;
                            }else if(this.tableElasticBlockStoreDate[i].category=='吞吐量优化型(HDD)卷'){
                                this.tableElasticBlockStoreDate[i].category=2;
                            }else if(this.tableElasticBlockStoreDate[i].category=='Cold HDD卷'){
                                this.tableElasticBlockStoreDate[i].category=3;
                            }else if(this.tableElasticBlockStoreDate[i].category=='EBS快照'){
                                this.tableElasticBlockStoreDate[i].category=4;
                            }

                            //服务类型
                            if(this.tableElasticBlockStoreDate[i].storageType=='EBS'){
                                this.tableElasticBlockStoreDate[i].storageType=0;
                            }else if(this.tableElasticBlockStoreDate[i].storageType=='RDS'){
                                this.tableElasticBlockStoreDate[i].storageType=1;
                            }

                            // 有iops
                            var EbsDTOListCopy=new Object();
                            EbsDTOListCopy.region=this.tableElasticBlockStoreDate[i].region;
                            EbsDTOListCopy.category=this.tableElasticBlockStoreDate[i].category;
                            EbsDTOListCopy.storage=this.tableElasticBlockStoreDate[i].storage.replace('GB','').replace('TB','');
                            EbsDTOListCopy.number=this.tableElasticBlockStoreDate[i].number;
                            EbsDTOListCopy.iops=this.tableElasticBlockStoreDate[i].iops;
                            EbsDTOListCopy.cost=this.tableElasticBlockStoreDate[i].cost.replace('￥','').replace('$','');
                            EbsDTOListCopy.unit=this.tableElasticBlockStoreDate[i].unit;
                            EbsDTOListCopy.usage=this.tableElasticBlockStoreDate[i].usage;
                            EbsDTOListCopy.month=this.tableElasticBlockStoreDate[i].month;
                            EbsDTOListCopy.storageType=this.tableElasticBlockStoreDate[i].storageType;
                            this.ebsDTOListCopyList.push(EbsDTOListCopy);

                        }

                        this.RDSDTOListCopyList=[];
                        // 增加rdsDTOList
                        /**********************************************************/
                        for(var i=0;i<this.relationalDatabaseServiceList.length;i++){
                            //区域
                            if(this.relationalDatabaseServiceList[i].region=='北京'){
                                this.relationalDatabaseServiceList[i].region='CN_NORTH_1';
                            }else if(this.relationalDatabaseServiceList[i].region=='新加坡'){
                                this.relationalDatabaseServiceList[i].region='AP_SOUTHEAST_1';
                            }

                            //数据库类型
                            if(this.relationalDatabaseServiceList[i].dbType=='MySQL'){
                                this.relationalDatabaseServiceList[i].dbType=0;
                            }else if(this.relationalDatabaseServiceList[i].dbType=='SQLServerEnterprise'){
                                this.relationalDatabaseServiceList[i].dbType=1;
                            }else if(this.relationalDatabaseServiceList[i].dbType=='SQLServerStandard'){
                                this.relationalDatabaseServiceList[i].dbType=1;
                            }

                             //部署方式
                            if(this.relationalDatabaseServiceList[i].deploymentOption=='单区域'){
                                this.relationalDatabaseServiceList[i].deploymentOption=0;
                            }else if(this.relationalDatabaseServiceList[i].deploymentOption=='多区域'){
                                this.relationalDatabaseServiceList[i].deploymentOption=1;
                            }

                            var RDSDTOListCopy=new Object();
                            RDSDTOListCopy.usage=this.relationalDatabaseServiceList[i].usage;
                            RDSDTOListCopy.region=this.relationalDatabaseServiceList[i].region;
                            RDSDTOListCopy.cpuCoreNumber=this.relationalDatabaseServiceList[i].cpuCoreNumber.replace('核','');
                            RDSDTOListCopy.ramSize=this.relationalDatabaseServiceList[i].ramSize.replace('G','');
                            RDSDTOListCopy.dbType=this.relationalDatabaseServiceList[i].dbType;
                            RDSDTOListCopy.paymentType=this.relationalDatabaseServiceList[i].paymentType;
                            RDSDTOListCopy.deploymentOption=this.relationalDatabaseServiceList[i].deploymentOption;
                            RDSDTOListCopy.number=this.relationalDatabaseServiceList[i].number;
                            RDSDTOListCopy.cost=this.relationalDatabaseServiceList[i].cost.replace('￥','').replace('$','');
                            RDSDTOListCopy.month=this.relationalDatabaseServiceList[i].month;
                            RDSDTOListCopy.instanceType=this.relationalDatabaseServiceList[i].instanceType;
                            RDSDTOListCopy.dbEdition=this.relationalDatabaseServiceList[i].dbEdition;
                            this.RDSDTOListCopyList.push(RDSDTOListCopy);
                        }
                        // 增加Project
                        /**********************************************************/
                        this.$api.project.createProject({
                            "name": this.preservationPlanForm.name,
                            "description": this.preservationPlanForm.describe,
                            "ec2DTOList": this.ec2DTOListCopyList,
                            "ebsDTOList": this.ebsDTOListCopyList,
                            "rdsDTOList": this.RDSDTOListCopyList
                        })
                        .then(res => {
                            this.selectList();
                            setTimeout(() => {
                                this.$refs[name].resetFields();//清空表格内的我们填写的数据
                                this.loading = false;
                                this.$nextTick(() => {
                                    this.loading = true;
                                });
                                this.$Message.success('添加成功');
                                //ec2表格数据为空
                                this.elasticComputeCloudList=[];
                                this.EC2priceTotalBeijing=0.00;
                                this.EC2priceTotalSingapore=0.00;
                                this.ec2Length=0;
                                //ebs表格数据为空
                                this.tableElasticBlockStoreDate=[];
                                this.EBSpriceTotalBeijing=0.00;
                                this.EBSpriceTotalSingapore=0.00;
                                this.EBSLength=0;
                                //rds表格数据为空
                                this.relationalDatabaseServiceList=[];
                                this.RDSpriceTotalBeijing=0.00;
                                this.RDSpriceTotalSingapore=0.00;
                                this.RDSLength=0;
                                this.isChange=false;
                                this.isSaveScenarios=true;
                                this.isExport=true;
                                this.isSaveas=true;
                                this.modal1 = false;
                                this.BeijingAWSTotal=0.00;
                                this.SingaporeAWSTotal=0.00;
                                this.preservationPlanForm.name='';
                                this.preservationPlanForm.describe='';
                            }, 1000);
                        })
                    }
                    else{
                        //解决iview 表单验证，验证提示error完成验证后，"确定"按钮一直转圈，点击不起作用问题
                        this.loading = false;
                        setTimeout(() => {
                            this.loading = true
                        }, 0)
                        this.$Message.error('添加失败');
                    }
                });
            },
            handleReset: function(name) {
                 this.$refs[name].resetFields();
            },
            // 查询projectList
            /**************************************************************************************/
            selectList: function(){
                this.$api.project.selectList("owner",getCookie('userName'))
                .then(res => {
                    this.projectList = res.data;
                })
            },
            //change 下拉框
            /**************************************************************************************/
            find: function(){
                //重置清空
                if(this.projects==undefined){
                    return;
                }
                //保存方案禁止点击
                this.isSaveScenarios=true;
                //可以点击另存为
                this.isSaveas=false;
                //可以点击导出报表
                this.isExport=false;
                //区域禁止选择
                this.isChange=true;
                this.$api.project.selectProject("id",this.projects)
                    .then(res => {
                        //另存为名称
                        this.saveForm.name=this.projects;
                        //另存为描述
                        this.saveForm.describe=this.projects;
                        // ec2
                        /**********************************************************/
                        // 北京
                        var priceEC2Bei=0.00;
                        // 新加坡
                        var priceEC2Singa=0.00;
                        this.elasticComputeCloudList=res.data.ec2DTOList;
                        this.ec2Length=this.elasticComputeCloudList.length;
                        for(var i=0;i<this.elasticComputeCloudList.length;i++){

                            // 地区
                            /**********************************************************/
                            if(this.elasticComputeCloudList[i].region=='CN_NORTH_1'){
                                //区域
                                this.elasticComputeCloudList[i].region='北京';
                                this.region=this.elasticComputeCloudList[i].region;
                                //单价
                                this.elasticComputeCloudList[i].cost="￥"+this.elasticComputeCloudList[i].cost;
                                //价格
                                /*************************************************/
                                this.elasticComputeCloudList[i].allPrice=(this.elasticComputeCloudList[i].cost.replace('￥','').replace('$',''))*this.elasticComputeCloudList[i].month*this.elasticComputeCloudList[i].number;
                                this.elasticComputeCloudList[i].allPrice="￥"+this.elasticComputeCloudList[i].allPrice.toFixed(2);
                                //相加
                                priceEC2Bei+=(this.elasticComputeCloudList[i].cost.replace('￥','').replace('$',''))*this.elasticComputeCloudList[i].month*this.elasticComputeCloudList[i].number;
                                //小计
                                /*************************************************/
                                this.EC2beiJingTotal=true;
                                this.EBSbeiJingTotal=true;
                                this.RDSbeiJingTotal=true;
                                this.EC2singaporeTotal=false;
                                this.RDSsingaporeTotal=false;
                                this.EBSsingaporeTotal=false;
                                //总计
                                this.awsBeijing=true;
                                this.awsSingapore=false;
                                //单位
                                this.moneyIconEC="￥";
                                this.moneyIconRDS="￥";
                                this.moneyIconEBS="￥";

                            }else if(this.elasticComputeCloudList[i].region=='AP_SOUTHEAST_1'){
                                //区域
                                this.elasticComputeCloudList[i].region='新加坡';
                                //单价
                                this.elasticComputeCloudList[i].cost="$"+this.elasticComputeCloudList[i].cost;
                                this.region=this.elasticComputeCloudList[i].region;
                                //价格
                                /*************************************************/
                                this.elasticComputeCloudList[i].allPrice=(this.elasticComputeCloudList[i].cost.replace('￥','').replace('$',''))*this.elasticComputeCloudList[i].month*this.elasticComputeCloudList[i].number;
                                this.elasticComputeCloudList[i].allPrice="$"+this.elasticComputeCloudList[i].allPrice.toFixed(2);
                                //相加
                                priceEC2Singa+=(this.elasticComputeCloudList[i].cost.replace('￥','').replace('$',''))*this.elasticComputeCloudList[i].month*this.elasticComputeCloudList[i].number;
                                //小计
                                /*************************************************/
                                this.EC2singaporeTotal=true;
                                this.RDSsingaporeTotal=true;
                                this.EBSsingaporeTotal=true;
                                this.EC2beiJingTotal=false;
                                this.RDSbeiJingTotal=false;
                                this.EBSbeiJingTotal=false;
                                //总计
                                this.awsBeijing=false;
                                this.awsSingapore=true;
                                //单位
                                this.moneyIconSingaporeEC="$";
                                this.moneyIconSingaporeEBS="$";
                                this.moneyIconSingaporeRDS="$";
                            }

                            if(priceEC2Bei==0){
                                priceEC2Bei=0.00;
                            }
                            if(priceEC2Singa==0){
                                priceEC2Singa=0.00;
                            }
                            //小计
                            this.EC2priceTotalBeijing=priceEC2Bei.toFixed(2);
                            this.EC2priceTotalSingapore=priceEC2Singa.toFixed(2);
                            //总计
                            this.BeijingAWSTotal=parseFloat(this.EC2priceTotalBeijing)+parseFloat(this.EBSpriceTotalBeijing)+parseFloat(this.RDSpriceTotalBeijing);
                            this.BeijingAWSTotal=this.BeijingAWSTotal.toFixed(2);
                            this.SingaporeAWSTotal=parseFloat(this.EC2priceTotalSingapore)+parseFloat(this.EBSpriceTotalSingapore)+parseFloat(this.RDSpriceTotalSingapore);
                            this.SingaporeAWSTotal=this.SingaporeAWSTotal.toFixed(2);

                            // cpu
                            this.elasticComputeCloudList[i].cpuCoreNumber=this.elasticComputeCloudList[i].cpuCoreNumber+"核";
                            // 内存
                            this.elasticComputeCloudList[i].ramSize=this.elasticComputeCloudList[i].ramSize+"G";
                            // 操作系统
                            if(this.elasticComputeCloudList[i].preInstalledSoftware==1){
                                this.elasticComputeCloudList[i].os='WindowsWithSQLEnterprise';
                            }else if(this.elasticComputeCloudList[i].preInstalledSoftware==3){
                                this.elasticComputeCloudList[i].os='WindowsWithSQLStandard';
                            }else if(this.elasticComputeCloudList[i].preInstalledSoftware==0){
                                this.elasticComputeCloudList[i].os=this.os[this.elasticComputeCloudList[i].os];
                            }
                        }
                        // ebs
                        /**********************************************************/
                        // 北京
                        var priceEBSBei=0.00;
                        // 新加坡
                        var priceEBSSinga=0.00;
                        this.tableElasticBlockStoreDate=res.data.ebsDTOList;
                        this.EBSLength=this.tableElasticBlockStoreDate.length;
                        this.EBSpriceTotalBeijing=0.00;
                        for(var i=0;i<this.tableElasticBlockStoreDate.length;i++){

                            // 地区
                            /**********************************************************/
                            if(this.tableElasticBlockStoreDate[i].region=='CN_NORTH_1'){
                                //区域
                                this.tableElasticBlockStoreDate[i].region='北京';
                                this.region=this.tableElasticBlockStoreDate[i].region;
                                //单价
                                this.tableElasticBlockStoreDate[i].cost="￥"+this.tableElasticBlockStoreDate[i].cost;
                                //价格
                                /*************************************************/
                                this.tableElasticBlockStoreDate[i].allPrice=(this.tableElasticBlockStoreDate[i].cost.replace('￥','').replace('$',''))*this.tableElasticBlockStoreDate[i].month*this.tableElasticBlockStoreDate[i].number;
                                this.tableElasticBlockStoreDate[i].allPrice="￥"+this.tableElasticBlockStoreDate[i].allPrice.toFixed(2);
                                //相加
                                priceEBSBei+=(this.tableElasticBlockStoreDate[i].cost.replace('￥','').replace('$',''))*this.tableElasticBlockStoreDate[i].month*this.tableElasticBlockStoreDate[i].number;
                                //小计
                                /*************************************************/
                                this.EC2beiJingTotal=true;
                                this.EBSbeiJingTotal=true;
                                this.RDSbeiJingTotal=true;
                                this.EC2singaporeTotal=false;
                                this.RDSsingaporeTotal=false;
                                this.EBSsingaporeTotal=false;
                                //总计
                                this.awsBeijing=true;
                                this.awsSingapore=false;
                                //单位
                                this.moneyIconEC="￥";
                                this.moneyIconRDS="￥";
                                this.moneyIconEBS="￥";

                            }else if(this.tableElasticBlockStoreDate[i].region=='AP_SOUTHEAST_1'){
                                //区域
                                this.tableElasticBlockStoreDate[i].region='新加坡';
                                this.region=this.tableElasticBlockStoreDate[i].region;
                                //单价
                                this.tableElasticBlockStoreDate[i].cost="$"+this.tableElasticBlockStoreDate[i].cost;
                                //价格
                                /*************************************************/
                                this.tableElasticBlockStoreDate[i].allPrice=(this.tableElasticBlockStoreDate[i].cost.replace('￥','').replace('$',''))*this.tableElasticBlockStoreDate[i].month*this.tableElasticBlockStoreDate[i].number;
                                this.tableElasticBlockStoreDate[i].allPrice="$"+this.tableElasticBlockStoreDate[i].allPrice.toFixed(2);
                                //相加
                                priceEBSSinga+=(this.tableElasticBlockStoreDate[i].cost.replace('￥','').replace('$',''))*this.tableElasticBlockStoreDate[i].month*this.tableElasticBlockStoreDate[i].number;
                                //小计
                                /*************************************************/
                                this.EC2singaporeTotal=true;
                                this.RDSsingaporeTotal=true;
                                this.EBSsingaporeTotal=true;
                                this.EC2beiJingTotal=false;
                                this.EBSbeiJingTotal=false;
                                this.RDSbeiJingTotal=false;
                                //总计
                                this.awsBeijing=false;
                                this.awsSingapore=true;
                                //单位
                                this.moneyIconSingaporeEC="$";
                                this.moneyIconSingaporeEBS="$";
                                this.moneyIconSingaporeRDS="$";
                            }

                            if(priceEBSBei==0){
                                priceEBSBei=0.00;
                            }
                            if(priceEBSSinga==0){
                                priceEBSSinga=0.00;
                            }
                            //小计
                            this.EBSpriceTotalBeijing=priceEBSBei.toFixed(2);
                            this.EBSpriceTotalSingapore=priceEBSSinga.toFixed(2);
                            //总计
                            this.BeijingAWSTotal=parseFloat(this.EC2priceTotalBeijing)+parseFloat(this.EBSpriceTotalBeijing)+parseFloat(this.RDSpriceTotalBeijing);
                            this.BeijingAWSTotal=this.BeijingAWSTotal.toFixed(2);
                            this.SingaporeAWSTotal=parseFloat(this.EC2priceTotalSingapore)+parseFloat(this.EBSpriceTotalSingapore)+parseFloat(this.RDSpriceTotalSingapore);
                            this.SingaporeAWSTotal=this.SingaporeAWSTotal.toFixed(2);

                            //存储类型
                            this.tableElasticBlockStoreDate[i].category=this.categorys[this.tableElasticBlockStoreDate[i].category];
                            //服务类型
                            this.tableElasticBlockStoreDate[i].storageType=this.storageTypes[this.tableElasticBlockStoreDate[i].storageType];
                            // 单位
                            var storage=this.tableElasticBlockStoreDate[i].unit==0?' GB':' TB';
                            // 存储容量
                            this.tableElasticBlockStoreDate[i].storage=this.tableElasticBlockStoreDate[i].storage+storage;
                            // 预配置的IOPS数量
                            this.tableElasticBlockStoreDate[i].iops=this.tableElasticBlockStoreDate[i].iops;
                            // if(this.tableElasticBlockStoreDate[i].iops == undefined){
                            //     this.tableElasticBlockStoreDate[i].iops = '---'
                            // }else{
                            //     this.tableElasticBlockStoreDate[i].iops=this.tableElasticBlockStoreDate[i].iops;
                            // }
                        }
                        // rds
                        /**********************************************************/
                        // 北京
                        var priceRDSBei=0.00;
                        // 新加坡
                        var priceRDSSinga=0.00;
                        this.relationalDatabaseServiceList=res.data.rdsDTOList;
                        this.RDSLength=this.relationalDatabaseServiceList.length;
                        for(var i=0;i<this.relationalDatabaseServiceList.length;i++){

                            // 地区
                            /**********************************************************/
                            if(this.relationalDatabaseServiceList[i].region=='CN_NORTH_1'){
                                //区域
                                this.relationalDatabaseServiceList[i].region='北京';
                                this.region=this.relationalDatabaseServiceList[i].region;
                                //单价
                                this.relationalDatabaseServiceList[i].cost="￥"+this.relationalDatabaseServiceList[i].cost;
                                //价格
                                /*************************************************/
                                this.relationalDatabaseServiceList[i].allPrice=(this.relationalDatabaseServiceList[i].cost.replace('￥','').replace('$',''))*this.relationalDatabaseServiceList[i].month*this.relationalDatabaseServiceList[i].number;
                                this.relationalDatabaseServiceList[i].allPrice="￥"+this.relationalDatabaseServiceList[i].allPrice.toFixed(2);
                                //相加
                                priceRDSBei+=(this.relationalDatabaseServiceList[i].cost.replace('￥','').replace('$',''))*this.relationalDatabaseServiceList[i].month*this.relationalDatabaseServiceList[i].number;
                                //小计
                                /*************************************************/
                                this.EC2beiJingTotal=true;
                                this.EBSbeiJingTotal=true;
                                this.RDSbeiJingTotal=true;
                                this.EC2singaporeTotal=false;
                                this.RDSsingaporeTotal=false;
                                this.EBSsingaporeTotal=false;
                                //总计
                                this.awsBeijing=true;
                                this.awsSingapore=false;
                                //单位
                                this.moneyIconEC="￥";
                                this.moneyIconRDS="￥";
                                this.moneyIconEBS="￥";

                            }else if(this.relationalDatabaseServiceList[i].region=='AP_SOUTHEAST_1'){
                                //区域
                                this.relationalDatabaseServiceList[i].region='新加坡';
                                //单价
                                this.relationalDatabaseServiceList[i].cost="$"+this.relationalDatabaseServiceList[i].cost;
                                this.region=this.relationalDatabaseServiceList[i].region;
                                //价格
                                /*************************************************/
                                this.relationalDatabaseServiceList[i].allPrice=(this.relationalDatabaseServiceList[i].cost.replace('￥','').replace('$',''))*this.relationalDatabaseServiceList[i].month*this.relationalDatabaseServiceList[i].number;
                                this.relationalDatabaseServiceList[i].allPrice="$"+this.relationalDatabaseServiceList[i].allPrice.toFixed(2);
                                //相加
                                priceRDSSinga+=(this.relationalDatabaseServiceList[i].cost.replace('￥','').replace('$',''))*this.relationalDatabaseServiceList[i].month*this.relationalDatabaseServiceList[i].number;
                                //小计
                                /*************************************************/
                                this.EC2singaporeTotal=true;
                                this.RDSsingaporeTotal=true;
                                this.EBSsingaporeTotal=true;
                                this.EC2beiJingTotal=false;
                                this.RDSbeiJingTotal=false;
                                this.EBSbeiJingTotal=false;
                                //总计
                                this.awsBeijing=false;
                                this.awsSingapore=true;
                                //单位
                                this.moneyIconSingaporeEC="$";
                                this.moneyIconSingaporeEBS="$";
                                this.moneyIconSingaporeRDS="$";
                            }

                            if(priceRDSBei==0){
                                priceRDSBei=0.00;
                            }
                            if(priceRDSSinga==0){
                                priceRDSSinga=0.00;
                            }
                            //小计
                            this.RDSpriceTotalBeijing=priceRDSBei.toFixed(2);
                            this.RDSpriceTotalSingapore=priceRDSSinga.toFixed(2);
                            //总计
                            this.BeijingAWSTotal=parseFloat(this.EC2priceTotalBeijing)+parseFloat(this.EBSpriceTotalBeijing)+parseFloat(this.RDSpriceTotalBeijing);
                            this.BeijingAWSTotal=this.BeijingAWSTotal.toFixed(2);
                            this.SingaporeAWSTotal=parseFloat(this.EC2priceTotalSingapore)+parseFloat(this.EBSpriceTotalSingapore)+parseFloat(this.RDSpriceTotalSingapore);
                            this.SingaporeAWSTotal=this.SingaporeAWSTotal.toFixed(2);

                            // cpu
                            this.relationalDatabaseServiceList[i].cpuCoreNumber=this.relationalDatabaseServiceList[i].cpuCoreNumber+"核";
                            // 内存
                            this.relationalDatabaseServiceList[i].ramSize=this.relationalDatabaseServiceList[i].ramSize+"G";
                            // 数据库类型
                            if(this.relationalDatabaseServiceList[i].dbEdition==1){
                                this.relationalDatabaseServiceList[i].dbType='SQLServerEnterprise';
                            }else if(this.relationalDatabaseServiceList[i].dbEdition==3){
                                this.relationalDatabaseServiceList[i].dbType='SQLServerStandard';
                            }else if(this.relationalDatabaseServiceList[i].dbEdition==0){
                                this.relationalDatabaseServiceList[i].dbType=this.dbType[this.relationalDatabaseServiceList[i].dbType];
                            }

                            //部署方式
                            if(this.relationalDatabaseServiceList[i].deploymentOption==0){
                                this.relationalDatabaseServiceList[i].deploymentOption='单区域';
                            }else if(this.relationalDatabaseServiceList[i].deploymentOption==1){
                                this.relationalDatabaseServiceList[i].deploymentOption='多区域';
                            }
                        }
                    })
            },
            //另存为
            /**************************************************************************************/
            saveProject:function(){
                for(var i=0;i<this.projectList.length;i++){
                    //名称
                    if(this.projectList[i].id==this.saveForm.name){
                        this.saveForm.name=this.projectList[i].name;
                        this.saveForm.describe=this.projectList[i].description;
                    }
                }
                //弹出模式框
                this.modal2=true;
            },
            SaveAshandleSubmit: function(name) {
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        //ec2用途不能为空
                        /**********************************************************/
                        if(this.elasticComputeCloudList.length>0){
                            for(var i=0;i<this.elasticComputeCloudList.length;i++){
                                if(this.elasticComputeCloudList[i].usage==undefined||this.elasticComputeCloudList[i].usage==''){
                                    this.loadingSaveAS = false;
                                    setTimeout(() => {
                                        this.loadingSaveAS = true
                                    }, 0)
                                    this.$Message.error('另存为失败,用途不能为空');
                                    this.modal2 = false;
                                    return;
                                }
                                if(this.elasticComputeCloudList[i].month==undefined||this.elasticComputeCloudList[i].month==''){
                                    this.loadingSaveAS = false;
                                    setTimeout(() => {
                                        this.loadingSaveAS = true
                                    }, 0)
                                    this.$Message.error('另存为失败,月不能为空');
                                    this.modal2 = false;
                                    return;
                                }
                            }
                        }
                        //ebs用途不能为空
                        if(this.tableElasticBlockStoreDate.length>0){
                            for(var i=0;i<this.tableElasticBlockStoreDate.length;i++){
                                if(this.tableElasticBlockStoreDate[i].usage==undefined||this.tableElasticBlockStoreDate[i].usage==''){
                                    this.loadingSaveAS = false;
                                    setTimeout(() => {
                                        this.loadingSaveAS = true
                                    }, 0)
                                    this.$Message.error('另存为失败,用途不能为空');
                                    this.modal2 = false;
                                    return;
                                }
                                if(this.tableElasticBlockStoreDate[i].month==undefined||this.tableElasticBlockStoreDate[i].month==''){
                                    this.loadingSaveAS = false;
                                    setTimeout(() => {
                                        this.loadingSaveAS = true
                                    }, 0)
                                    this.$Message.error('另存为失败,月不能为空');
                                    this.modal2 = false;
                                    return;
                                }
                            }
                        }
                        //rds用途不能为空
                        if(this.relationalDatabaseServiceList.length>0){
                            for(var i=0;i<this.relationalDatabaseServiceList.length;i++){
                                if(this.relationalDatabaseServiceList[i].usage==undefined||this.relationalDatabaseServiceList[i].usage==''){
                                    this.loadingSaveAS = false;
                                    setTimeout(() => {
                                        this.loadingSaveAS = true
                                    }, 0)
                                    this.$Message.error('另存为失败,用途不能为空');
                                    this.modal2 = false;
                                    return;
                                }
                                if(this.relationalDatabaseServiceList[i].month==undefined||this.relationalDatabaseServiceList[i].month==''){
                                    this.loadingSaveAS = false;
                                    setTimeout(() => {
                                        this.loadingSaveAS = true
                                    }, 0)
                                    this.$Message.error('另存为失败,月不能为空');
                                    this.modal2 = false;
                                    return;
                                }
                            }
                        }
                        this.ec2DTOListCopyListUpdate=[];
                        // 增加ec2DTOList
                        /**********************************************************/
                        for(var i=0;i<this.elasticComputeCloudList.length;i++){
                            //区域
                            if(this.elasticComputeCloudList[i].region=='北京'){
                                this.elasticComputeCloudList[i].region='CN_NORTH_1';
                            }else if(this.elasticComputeCloudList[i].region=='新加坡'){
                                this.elasticComputeCloudList[i].region='AP_SOUTHEAST_1';
                            }

                            //操作系统
                            if(this.elasticComputeCloudList[i].os=='Windows'){
                                this.elasticComputeCloudList[i].os=1;
                            }else if(this.elasticComputeCloudList[i].os=='Red Hat Enterprise Linux'){
                                this.elasticComputeCloudList[i].os=0;
                            }else if(this.elasticComputeCloudList[i].os=='Linux/UNIX'){
                                this.elasticComputeCloudList[i].os=2;
                            }else if(this.elasticComputeCloudList[i].os=='WindowsWithSQLEnterprise'){
                                this.elasticComputeCloudList[i].os=1;
                            }else if(this.elasticComputeCloudList[i].os=='WindowsWithSQLStandard'){
                                this.elasticComputeCloudList[i].os=1;
                            }

                            var Ec2DTOListCopyUpdate=new Object();
                            Ec2DTOListCopyUpdate.region=this.elasticComputeCloudList[i].region;
                            Ec2DTOListCopyUpdate.cpuCoreNumber=this.elasticComputeCloudList[i].cpuCoreNumber.replace('核','');
                            Ec2DTOListCopyUpdate.ramSize=this.elasticComputeCloudList[i].ramSize.replace('G','');
                            Ec2DTOListCopyUpdate.os=this.elasticComputeCloudList[i].os;
                            Ec2DTOListCopyUpdate.paymentType=this.elasticComputeCloudList[i].paymentType;
                            Ec2DTOListCopyUpdate.number=this.elasticComputeCloudList[i].number;
                            Ec2DTOListCopyUpdate.cost=this.elasticComputeCloudList[i].cost.replace('￥','').replace('$','');
                            Ec2DTOListCopyUpdate.instanceType=this.elasticComputeCloudList[i].instanceType;
                            Ec2DTOListCopyUpdate.usage=this.elasticComputeCloudList[i].usage;
                            Ec2DTOListCopyUpdate.month=this.elasticComputeCloudList[i].month;
                            Ec2DTOListCopyUpdate.preInstalledSoftware=this.elasticComputeCloudList[i].preInstalledSoftware;
                            this.ec2DTOListCopyListUpdate.push(Ec2DTOListCopyUpdate);
                        }
                        this.ebsDTOListCopyListUpdate=[];
                        // 增加ebsDTOList
                        /**********************************************************/
                        for(var i=0;i<this.tableElasticBlockStoreDate.length;i++){
                            //区域
                            if(this.tableElasticBlockStoreDate[i].region=='北京'){
                                this.tableElasticBlockStoreDate[i].region='CN_NORTH_1';
                            }else if(this.tableElasticBlockStoreDate[i].region=='新加坡'){
                                this.tableElasticBlockStoreDate[i].region='AP_SOUTHEAST_1';
                            }

                            //存储类型
                            if(this.tableElasticBlockStoreDate[i].category=='通用型(SSD)卷'){
                                this.tableElasticBlockStoreDate[i].category=0;
                            }else if(this.tableElasticBlockStoreDate[i].category=='预配置IOPS(SSD)卷'){
                                this.tableElasticBlockStoreDate[i].category=1;
                            }else if(this.tableElasticBlockStoreDate[i].category=='吞吐量优化型(HDD)卷'){
                                this.tableElasticBlockStoreDate[i].category=2;
                            }else if(this.tableElasticBlockStoreDate[i].category=='Cold HDD卷'){
                                this.tableElasticBlockStoreDate[i].category=3;
                            }else if(this.tableElasticBlockStoreDate[i].category=='EBS快照'){
                                this.tableElasticBlockStoreDate[i].category=4;
                            }

                            //服务类型
                            if(this.tableElasticBlockStoreDate[i].storageType=='EBS'){
                                this.tableElasticBlockStoreDate[i].storageType=0;
                            }else if(this.tableElasticBlockStoreDate[i].storageType=='RDS'){
                                this.tableElasticBlockStoreDate[i].storageType=1;
                            }

                            // 有iops
                            var EbsDTOListCopyUpdate=new Object();
                            EbsDTOListCopyUpdate.region=this.tableElasticBlockStoreDate[i].region;
                            EbsDTOListCopyUpdate.category=this.tableElasticBlockStoreDate[i].category;
                            EbsDTOListCopyUpdate.storage=this.tableElasticBlockStoreDate[i].storage.replace('GB','').replace('TB','');
                            EbsDTOListCopyUpdate.number=this.tableElasticBlockStoreDate[i].number;
                            EbsDTOListCopyUpdate.iops=this.tableElasticBlockStoreDate[i].iops;
                            EbsDTOListCopyUpdate.cost=this.tableElasticBlockStoreDate[i].cost.replace('￥','').replace('$','');
                            EbsDTOListCopyUpdate.unit=this.tableElasticBlockStoreDate[i].unit;
                            EbsDTOListCopyUpdate.usage=this.tableElasticBlockStoreDate[i].usage;
                            EbsDTOListCopyUpdate.storageType=this.tableElasticBlockStoreDate[i].storageType;
                            EbsDTOListCopyUpdate.month=this.tableElasticBlockStoreDate[i].month;
                            this.ebsDTOListCopyListUpdate.push(EbsDTOListCopyUpdate);

                        }
                        this.RDSDTOListCopyListUpdate=[];
                        // 增加rdsDTOList
                        /**********************************************************/
                        for(var i=0;i<this.relationalDatabaseServiceList.length;i++){
                            //区域
                            if(this.relationalDatabaseServiceList[i].region=='北京'){
                                this.relationalDatabaseServiceList[i].region='CN_NORTH_1';
                            }else if(this.relationalDatabaseServiceList[i].region=='新加坡'){
                                this.relationalDatabaseServiceList[i].region='AP_SOUTHEAST_1';
                            }

                            //数据库类型
                            if(this.relationalDatabaseServiceList[i].dbType=='MySQL'){
                                this.relationalDatabaseServiceList[i].dbType=0;
                            }else if(this.relationalDatabaseServiceList[i].dbType=='SQLServerEnterprise'){
                                this.relationalDatabaseServiceList[i].dbType=1;
                            }else if(this.relationalDatabaseServiceList[i].dbType=='SQLServerStandard'){
                                this.relationalDatabaseServiceList[i].dbType=1;
                            }

                             //部署方式
                            if(this.relationalDatabaseServiceList[i].deploymentOption=='单区域'){
                                this.relationalDatabaseServiceList[i].deploymentOption=0;
                            }else if(this.relationalDatabaseServiceList[i].deploymentOption=='多区域'){
                                this.relationalDatabaseServiceList[i].deploymentOption=1;
                            }

                            var RDSDTOListCopyUpdate=new Object();
                            RDSDTOListCopyUpdate.usage=this.relationalDatabaseServiceList[i].usage;
                            RDSDTOListCopyUpdate.region=this.relationalDatabaseServiceList[i].region;
                            RDSDTOListCopyUpdate.cpuCoreNumber=this.relationalDatabaseServiceList[i].cpuCoreNumber.replace('核','');
                            RDSDTOListCopyUpdate.ramSize=this.relationalDatabaseServiceList[i].ramSize.replace('G','');
                            RDSDTOListCopyUpdate.dbType=this.relationalDatabaseServiceList[i].dbType;
                            RDSDTOListCopyUpdate.paymentType=this.relationalDatabaseServiceList[i].paymentType;
                            RDSDTOListCopyUpdate.deploymentOption=this.relationalDatabaseServiceList[i].deploymentOption;
                            RDSDTOListCopyUpdate.number=this.relationalDatabaseServiceList[i].number;
                            RDSDTOListCopyUpdate.cost=this.relationalDatabaseServiceList[i].cost.replace('￥','').replace('$','');
                            RDSDTOListCopyUpdate.month=this.relationalDatabaseServiceList[i].month;
                            RDSDTOListCopyUpdate.instanceType=this.relationalDatabaseServiceList[i].instanceType;
                            RDSDTOListCopyUpdate.dbEdition=this.relationalDatabaseServiceList[i].dbEdition;
                            this.RDSDTOListCopyListUpdate.push(RDSDTOListCopyUpdate);
                        }
                        // 更新Project
                        /**********************************************************/
                        this.$api.project.updateProject({
                            "name": this.saveForm.name,
                            "description": this.saveForm.describe,
                            "id":this.projects,
                            "ec2DTOList":this.ec2DTOListCopyListUpdate,
                            "ebsDTOList":this.ebsDTOListCopyListUpdate,
                            "rdsDTOList":this.RDSDTOListCopyListUpdate
                        })
                        .then(res => {
                            this.selectList();
                            setTimeout(() => {
                                this.$refs[name].resetFields();//清空表格内的我们填写的数据
                                this.loadingSaveAS = false;
                                this.$nextTick(() => {
                                    this.loadingSaveAS = true;
                                });
                                //ec2表格数据为空
                                this.$Message.success('添加成功');
                                this.elasticComputeCloudList=[];
                                this.EC2priceTotalBeijing=0.00;
                                this.EC2priceTotalSingapore=0.00;
                                this.ec2Length=0;
                                this.BeijingAWSTotal=0.00;
                                this.SingaporeAWSTotal=0.00;
                                //ebs表格数据为空
                                this.tableElasticBlockStoreDate=[];
                                this.EBSpriceTotalBeijing=0.00;
                                this.EBSpriceTotalSingapore=0.00;
                                this.EBSLength=0;
                                this.BeijingAWSTotal=0.00;
                                this.SingaporeAWSTotal=0.00;
                                this.projects='请选择';
                                this.isChange=false;
                                this.isSaveScenarios=true;
                                this.isExport=true;
                                this.isSaveas=true;
                                this.modal2 = false;
                                //rds表格数据为空
                                this.RDSLength=0;
                                this.RDSpriceTotalBeijing=0.00;
                                this.RDSpriceTotalSingapore=0.00;
                                this.relationalDatabaseServiceList=[];
                            }, 1000);
                        })
                        .catch(err => {
                            setTimeout(() => {
                                this.loadingSaveAS = false;
                                this.modal2 = true;
                            }, 1000);
                            
                        })
                    }
                    else{
                        //解决iview 表单验证，验证提示error完成验证后，"确定"按钮一直转圈，点击不起作用问题
                        this.loadingSaveAS = false;
                        setTimeout(() => {
                            this.loadingSaveAS = true
                        }, 0)
                        this.$Message.error('添加失败');
                    }
                });
            },
            SaveAshandleReset: function(name) {
                // this.$refs[name].resetFields();
            }
        }
    }
</script>

<style scoped>
    .costCalculation-main
    {
        left: 253px;
        right: 0px;
        top: 64px;
        bottom: 70px;
        overflow-y: auto;
        position: fixed;
    }
    .CostCalculation-title
    {
        width: 100%;
        font-size: 13px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        padding: 15px 0px 8px 10px;
        font-weight: 600;
    }
    .CostCalculation-top
    {
        width: 100%;
        height: 53px;
        margin-bottom: 10px;
        background-color: #fff;
    }
    /*EC2*/
    .EC2-title
    {
        width: 100%;
        height: 38px;
        background-color: white;
        border-left: 1px solid #d8d9db;
        border-right: 1px solid #d8d9db;
        border-top: 1px solid #d8d9db;
        line-height: 38px;
        overflow: hidden;
    }
    .EC2-title>div:nth-child(1)
    {
        width: 10%;
        margin-left: 17px;
        font-size: 13px;
        font-weight: 600;
        float: left;
    }

    .EC2-foot
    {
        width: 100%;
        height: 38px;
        background-color: white;
        border-left: 1px solid #d8d9db;
        border-right: 1px solid #d8d9db;
        border-bottom: 1px solid #d8d9db;
        text-align: right;
        line-height: 38px;
        margin-bottom: 20px;
    }
    .EC2-foot>div
    {
        margin-right: 71px;
    }
    /*EBS*/
    .EBS-title
    {
        width: 100%;
        height: 38px;
        background-color: white;
        border-left: 1px solid #d8d9db;
        border-right: 1px solid #d8d9db;
        border-top: 1px solid #d8d9db;
        line-height: 38px;
        overflow: hidden;
    }
    .EBS-title>div:nth-child(1)
    {
        margin-left: 17px;
        font-size: 13px;
        font-weight: 600;
        float: left;
    }
    .EBS-title>span
    {
        float: right;
        width: 25px;
        height: 25px;
        border-radius: 50%;
        display: block;
        background-color: #2db7f5;
        text-align: center;
        line-height: 25px;
        color: #fff;
        font-size: 19px;
        margin-top: 7px;
        margin-right: 10px;
    }
    .EBS-foot
    {
        width: 100%;
        height: 38px;
        background-color: white;
        border-left: 1px solid #d8d9db;
        border-right: 1px solid #d8d9db;
        border-bottom: 1px solid #d8d9db;
        text-align: right;
        line-height: 38px;
        margin-bottom:20px;
    }
    .EBS-foot>div
    {
        margin-right: 71px;
    }
    /*RDS*/
    .RDS-title
    {
        width: 100%;
        height: 38px;
        background-color: white;
        border-left: 1px solid #d8d9db;
        border-right: 1px solid #d8d9db;
        border-top: 1px solid #d8d9db;
        line-height: 38px;
        overflow: hidden;
    }
    .RDS-title>div:nth-child(1)
    {
        width: 10%;
        margin-left: 17px;
        font-size: 13px;
        font-weight: 600;
        float: left;
    }

    .RDS-foot
    {
        width: 100%;
        height: 38px;
        background-color: white;
        border-left: 1px solid #d8d9db;
        border-right: 1px solid #d8d9db;
        border-bottom: 1px solid #d8d9db;
        text-align: right;
        line-height: 38px;
        margin-bottom: 20px;
    }
    .RDS-foot>div
    {
        margin-right: 71px;
    }
    /*尾*/
    .CostCalculation-foot
    {
        position: fixed;
        left: 240px;
        right: 0;
        bottom: 0;
        height: 70px;
        background-color: #f1f1f3;
        line-height: 70px;
    }
    .total
    {
        font-size: 14px;
        padding-left: 13px;

    }
    .costCalculationSearch
    {
        background-color: #fff;
        height: 51px;
        padding: 10px;
    }
</style>



// WEBPACK FOOTER //
// src/components/ebilling/cost_calculation/CostCalculation.vue